const doorState = {
  UNLOADING: 'UNLOADING',
  LOADING: 'LOADING',
  EMPTY: 'EMPTY',
  STOPPED: 'STOPPED',
  NOT_STARTED: 'NOT STARTED',
  FINISHED: 'COMPLETE',
};

const getColor = state => ({
  [doorState.FINISHED]: '#1560AD',
  [doorState.STOPPED]: '#F5222D',
  [doorState.NOT_STARTED]: '#232526',
  [doorState.EMPTY]: '#828C94',
})[state];

const getOptions = () => ([
  {
    label: 'Empty',
    value: doorState.EMPTY,
  },
  {
    label: 'Not Started',
    value: doorState.NOT_STARTED,
  },
  {
    label: 'Unloading',
    value: doorState.UNLOADING,
  },
  {
    label: 'Stopped',
    value: doorState.STOPPED,
  },
  {
    label: 'Finished',
    value: doorState.FINISHED,
  },
]);

export default {
  ...doorState,
  getColor,
  getOptions,
};
